export default __webpack_public_path__ + "static/media/icon_withdraw_active.7210cab7.svg";